var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIndents = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 268,
    height: 40,
    viewBox: "0 0 268 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 267,
    height: 39,
    rx: 5.5,
    fill: "white",
    stroke: "#EAEDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 6C0 2.68629 2.68629 0 6 0H12V40H6C2.68629 40 0 37.3137 0 34V6Z",
    fill: "#D4F3E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M256 0H262C265.314 0 268 2.68629 268 6V34C268 37.3137 265.314 40 262 40H256V0Z",
    fill: "#D4F3E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M0 28H268V34C268 37.3137 265.314 40 262 40H5.99999C2.68629 40 0 37.3137 0 34V28Z",
    fill: "#D4F3E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M268 12L0 12V6C0 2.68629 2.68628 0 6 0L262 0C265.314 0 268 2.68629 268 6V12Z",
    fill: "#D4F3E4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIndents);
export default ForwardRef;